import { render, staticRenderFns } from "./MotionScale.vue?vue&type=template&id=a6f46e3c"
import script from "./MotionScale.vue?vue&type=script&lang=js"
export * from "./MotionScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports